import React, { createContext } from 'react';

export interface Settings {
    userSettings: any;
    businessEntitySettings: any;
    formulationSettings: any;
    accountingSettings: any;
    currency?: any;
}

const SettingsContext = createContext({
    settings: {
        userSettings: {},
        businessEntitySettings: {},
        accountingSettings: {},
        formulationSettings: {},
        currency: null,
    } as Settings,
    setSettings: (values: any) => {},
});

export default SettingsContext;
